<template>
  <section class="form-contact">
    <h2 class="text-center text-orange" v-if="title" v-once>{{ title }}</h2>
    <div class="form-contact-content">
      <form @submit.prevent="submit" ref="formContact" id="form-contact" :key="componentKey">
        <slot name="form-top"></slot>
        <field
          has-border
          is-small
          placeholder="Selecionar Área desejada"
          v-if="!this.$props.id"
        >
          <template v-slot:default="{ changeFocus }">
            <select
              required
              v-model="Area"
              @focus="changeFocus(true)"
              name="Area"
            >
              <option v-for="(area, key) in areas" :key="key" :value="area.id">
                {{ area.name }}
              </option>
            </select>
          </template>
        </field>

        <field
          helper-text="Nome Completo"
          has-border
          is-small
          placeholder="Nome"
          :input="{ type: 'text', name: 'Nome', required: 'required' }"
        />

        <field
          helper-text="email@email.com"
          has-border
          is-small
          placeholder="E-mail"
          :input="{ type: 'email', name: 'Email', required: 'required' }"
        />

        <field
          helper-text="(11) 2345-6789"
          has-border
          is-small
          placeholder="Telefone"
          :input="{ type: 'tel', name: 'Telefone', required: 'required' }"
        />

        <field has-border is-small placeholder="Mensagem">
          <template v-slot:default="{ changeFocus }">
            <textarea
              required
              name="Mensagem"
              @blur="changeFocus(false)"
              @focus="changeFocus(true)"
            ></textarea>
          </template>
        </field>
        <p class="text-center">
          <button type="submit" class="button button-orange">ENVIAR</button>
        </p>
      </form>
      <aside class="form-contact-info">
        <slot name="info"></slot>
      </aside>

      <modal :active.sync="modalContactIsOpen">
        <div class="text-center">
          <h3>Sua mensagem foi enviada com sucesso!</h3>
        </div>
      </modal>
    </div>
  </section>
</template>

<script>
import Field from "./Field";
import api from "../services/api";
import qs from "querystring";
import Modal from "@/components/Modal";

export default {
  components: { Field, Modal },
  props: {
    title: String,
    id: String,
  },

  data() {
    return {
      modalContactIsOpen: false,
       componentKey: 0,
      areas: []
    };
  },

  async created() {
    await this.getAreas();
  },

  methods: {
    async getAreas() {
      if (!this.$props.id) {
        const { data: areas } = await api.get("contact/areas");
        this.areas = areas;
      }
    },

    async submit() {
      // this.loading = true;
      // console.log("dsds");
      try {
        var nome = document.querySelector('[name="Nome"]').value;
        var email = document.querySelector('[name="Email"]').value;
        var telefone = document.querySelector('[name="Telefone"]').value;
        var mensagem = document.querySelector('[name="Mensagem"]').value;
        var area = "";

        if (!this.$props.id)
          area = document.querySelector('[name="Area"]').value;

        const requestBody = {
          Nome: nome,
          Email: email,
          Telefone: telefone,
          AreaContatoId: area,
          Mensagem: mensagem,
          SocioId: this.$props.id,
        };

        await api
          .post("contact", qs.stringify(requestBody))
          .then(() => {
            this.modalContactIsOpen = true;
            this.componentKey += 1;
          })
          .catch(() => {
            alert(
              "Aconteceu um erro no envio de seu agendamento, Para mais dúvidas, ligue para (11) 3376-0100"
            );
          });
      } finally {
        // this.loading = false;
      }
    },
  },
};
</script>

<style>
</style>
